import { A } from '@solidjs/router'
import { onCleanup } from 'solid-js'
import { getAssetUrl } from '/web/shared/util'
import { settingStore } from '/web/store'
import { getModelUrl } from '/web/shared/aifans/lib/model-util'
import { AppSchema } from '/common/types'
import { IconUser } from '/web/shared/aifans/Icons'

interface Props {
  image?: string
  name?: string
  id?: string
  opened?: boolean
  character?: AppSchema.Character
}

const ChatHeaderAiFans = (props: Props) => {
  const state = settingStore()

  onCleanup(() => {
    settingStore.rightNav(false)
  })

  return (
    <div
      class="flex w-full items-center gap-3 px-[18px] py-[14px]"
      style={{
        background: 'var(--cf-surface)',
        'border-bottom': '1px solid var(--cf-hairline)',
        'flex-shrink': '0',
      }}
    >
      {/* Back button -- mobile only */}
      <button
        class="grid h-9 w-9 place-items-center rounded-full md:hidden"
        style={{ background: 'rgba(255,255,255,0.05)', color: 'var(--cf-text)' }}
        onClick={() => settingStore.leftPanelMobile(true)}
      >
        <svg
          viewBox="0 0 24 24"
          width="18"
          height="18"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
      </button>

      {/* Avatar -- 40px round */}
      {props.image && (
        <A href={getModelUrl(props.character?.categorySlug, props.character?.slug || props.id)}>
          <img
            class="h-10 w-10 rounded-full object-cover"
            style={{ background: 'linear-gradient(135deg, var(--cf-primary), var(--cf-accent))' }}
            src={getAssetUrl(props.image)}
            alt={props.name}
          />
        </A>
      )}

      {/* Name + online status */}
      <div class="min-w-0 flex-1">
        <A href={getModelUrl(props.character?.categorySlug, props.character?.slug || props.id)}>
          <div class="font-rajdhani text-[15px] font-bold text-white">{props.name}</div>
        </A>
        <div class="flex items-center gap-1.5">
          <span
            class="h-[6px] w-[6px] rounded-full"
            style={{ background: '#2dc653', 'box-shadow': '0 0 6px rgba(45,198,83,0.5)' }}
          />
          <span class="font-rajdhani text-[11px] font-semibold" style={{ color: '#2dc653' }}>
            Online
          </span>
        </div>
      </div>

      {/* Profile toggle -- desktop */}
      <button
        class="hidden h-9 w-9 place-items-center rounded-full transition-colors md:grid xl:hidden"
        style={{
          border: '1px solid rgba(255,255,255,0.08)',
          background: 'rgba(255,255,255,0.04)',
          color: 'rgba(255,255,255,0.6)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = 'rgba(0,229,255,0.3)'
          e.currentTarget.style.color = '#fff'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'
          e.currentTarget.style.color = 'rgba(255,255,255,0.6)'
        }}
        onClick={() => settingStore.rightNav(!state.showRightNav)}
      >
        <IconUser size={18} />
      </button>
      {/* Profile toggle -- mobile */}
      <button
        class="grid h-9 w-9 place-items-center rounded-full md:hidden"
        style={{
          border: '1px solid rgba(255,255,255,0.08)',
          background: 'rgba(255,255,255,0.04)',
          color: 'rgba(255,255,255,0.6)',
        }}
        onClick={() => {
          settingStore.rightNav(true)
          settingStore.rightNavMobile()
        }}
      >
        <IconUser size={18} />
      </button>
    </div>
  )
}

export default ChatHeaderAiFans
